import clsx from 'clsx'
import type { CSSProperties } from 'react'
import { useEffect, useRef } from 'react'

import S from './MultiSelectContents.style'
import type { MultiSelectDropdownCommonProps, MultiSelectDropdownData } from './types'

type Props<DataT extends MultiSelectDropdownData> = {
  width?: CSSProperties['width']
  label?: Record<string, string>
} & MultiSelectDropdownCommonProps<DataT>

const MultiSelectContents = <DataT extends MultiSelectDropdownData>({
  width,
  data,
  label,
  onSelect,
  selectedData,
}: Props<DataT>) => {
  const ref = useRef<HTMLUListElement>(null)
  useEffect(() => {
    if (!ref.current) return
    // 각 li active된 아이템이 스크롤 가운데로 오게  (intoview 버그 있어서 이렇게 사용)
    ref.current.querySelectorAll<HTMLLIElement>('.multiple-select-list').forEach((scrollEl) => {
      const activeEl = scrollEl.querySelector<HTMLDivElement>('.multiple-select-item.active')

      if (scrollEl && activeEl) {
        const scrollActiveItemCenter =
          activeEl.offsetTop - scrollEl.offsetHeight / 2 + activeEl.offsetHeight / 2
        scrollEl.scrollTop = scrollActiveItemCenter
      }
    })
  }, [])
  return (
    <ul css={S.multipleSelectContents} style={{ width }} ref={ref}>
      {data.map(([name, values]) => (
        <li
          key={name}
          data-mathflat-unique-id={name}
          css={S.multipleSelectList}
          className="multiple-select-list"
        >
          {values.map((value, i) => {
            const isActive = value === selectedData[name]
            return (
              <div
                key={`${name}-${i}`}
                data-mathflat-unique-id={`${name}-${i}`}
                css={S.multipleSelectItem}
                className={clsx('multiple-select-item', isActive && 'active')}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    onSelect(name, value)
                  }}
                >
                  {label ? `${value}${label[name]}` : value}
                </button>
              </div>
            )
          })}
        </li>
      ))}
    </ul>
  )
}

export default MultiSelectContents
